let _platform: string | undefined;

export function getPlatform(): string {
  if (_platform) return _platform;

  if (import.meta.server) {
    _platform = process.env.NUXT_PUBLIC_PLATFORM || 'desktop';
  } else {
    const runtimeConfig = useRuntimeConfig();
    _platform = runtimeConfig.public.platform;
  }

  return _platform;
}
